"use client"

import React, {useEffect, useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import styles from "@/app/(index)/index.module.css";
import {Divider, Image, UnstyledButton} from "@mantine/core";
import HisDirector from "@/app/(index)/leader/[name]/his-director";
import {useMediaQuery} from "@mantine/hooks";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700', '800', '900'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const Page = ({params}: { params: { name: string } }) => {
    const { fontSize, lang } = useGlobalStateStore();
    const loadCurrentFontSize = (s: number, m: number, l: number) => {
        if(fontSize == 0) return `text-[${s}px]`;
        else if(fontSize == 1) return `text-[${m}px]`;
        else if(fontSize == 2) return `text-[${l}px]`;
    }
     const [tab, setTab] = useState<string>('mainDirector');

    useEffect(() => {
        console.log(params.name);

        if(params.name.toLowerCase() == 'deputy-director-general'){
            setTab('subDirector');
        }
    }, []);

    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <Bread name_c="關於科政中心 - 中心首長" name_e="About STPI - Introduction of Director General"/>
                    )
                }
                <div
                    className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] pb-[45px] text-[#5b5b5b] text-[35px] font-bold">
                        {
                            lang == "tw" ? "中心首長" : "Introduction"
                        }
                    </div>


                    <div>
                        <div className={cx("flex gap-1 border-b border-[#79b7b4]", mediaQueryLessSM ? 'justify-end' : 'justify-between text-xs')}>
                            <UnstyledButton onClick={() => setTab('mainDirector')}>
                                <div
                                    className={cx(tab === 'mainDirector' ? styles.bookmarkBG1Active : styles.bookmarkBG1,
                                        "text-white py-[10px] px-[35px] font-bold", loadCurrentFontSize(14, 18, 20))}>
                                    {lang == "tw" ? "主任" : "Director General"}
                                </div>
                            </UnstyledButton>
                            <UnstyledButton onClick={() => setTab('subDirector')}>
                                <div
                                    className={cx(tab === 'subDirector' ? styles.bookmarkBG1Active : styles.bookmarkBG1,
                                        "text-white py-[10px] px-[35px] font-bold", loadCurrentFontSize(14, 18, 20))}>
                                    {lang == "tw" ? "副主任" : "Deputy Director General"}
                                </div>
                            </UnstyledButton>
                            {/*<UnstyledButton onClick={() => setTab('subDirector2')}>*/}
                            {/*    <div*/}
                            {/*        className={cx(tab === 'subDirector2' ? styles.bookmarkBG1Active : styles.bookmarkBG1,*/}
                            {/*            "text-white py-[10px] px-[35px] font-bold", loadCurrentFontSize(14, 18, 20))}>*/}
                            {/*        {lang == "tw" ? "副主任" : "Deputy Director General"}*/}
                            {/*    </div>*/}
                            {/*</UnstyledButton>*/}
                            <UnstyledButton onClick={() => setTab('hisDirector')}>
                                <div
                                    className={cx(tab === 'hisDirector' ? styles.bookmarkBG1Active : styles.bookmarkBG1,
                                        "text-white py-[10px] px-[35px] font-bold", loadCurrentFontSize(14, 18, 20))}>
                                    {lang == "tw" ? "歷屆主任" : "Former Director Generals"}
                                </div>
                            </UnstyledButton>
                        </div>
                    </div>


                    <div className="mt-[60px]">
                        {
                            tab === 'mainDirector' && (
                                <div className={cx("flex", mediaQueryLessSM ? 'gap-[120px]' : 'flex-col gap-10 px-[10px]')}>
                                    <div className={cx(!mediaQueryLessSM && 'flex justify-center')}>
                                        <Image src="/images/mainDirector_liao.jpg" alt={lang === "tw" ? "廖肇寧主任" : "Director General Chao-Ning Liao"} h={467} w={340} radius={30}/>
                                    </div>
                                    {lang == "tw" && (
                                        <div className="flex flex-col flex-1">
                                            <div className="flex flex-col">
                                                <div className="text-[30px] text-black">主任</div>
                                                <div className="text-[46px] text-[#8d7f4c] font-extrabold">廖肇寧</div>
                                            </div>
                                            <Divider color={"#cedbdc"} mb={40} mt={40}/>
                                            <div className="flex flex-col">
                                                <div className="text-[30px] text-black font-bold">學歷</div>
                                                <div className="text-[20px] leading-[40px]">
                                                    <div>美國伊利諾大學香檳分校農業經濟學博士</div>
                                                    <div>國立中正大學國際經濟研究所碩士</div>
                                                    <div>國立清華大學經濟學系學士</div>
                                                </div>
                                                <div className="text-[30px] text-black font-bold mt-[30px]">經歷</div>
                                                <div className="text-[20px] leading-[40px]">
                                                    <div>國立清華大學經濟學系主任</div>
                                                    <div>國立清華大學科技管理學院學士班主任</div>
                                                    <div>台灣環境與資源經濟學會常務理事</div>
                                                    <div>綠色經濟期刊編輯委員</div>
                                                    <div>國立清華大學經濟學系教授</div>
                                                    <div>國立成功大學經濟學系代理主任</div>
                                                    <div>台灣經濟研究院研究人員</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {lang == "en" && (
                                        <div className="flex flex-col flex-1">
                                            <div className="flex flex-col">
                                                <div className="text-[30px] text-black">Director General</div>
                                                <div className="text-[46px] text-[#8d7f4c] font-extrabold">Chao-Ning Liao</div>
                                            </div>
                                            <Divider color={"#cedbdc"} mb={40} mt={40}/>
                                            <div className="flex flex-col">
                                                <div className="text-[30px] text-black font-bold">Education</div>
                                                <ul className="text-[20px] leading-[40px] list-disc list-inside">
                                                    <li>Ph.D., Agricultural Economics, University of Illinois, Urbana-Champaign, U.S.A.</li>
                                                    <li>M.S., International Economics, National Chung Cheng University</li>
                                                    <li>B.S., Economics, National Tsing Hua University</li>
                                                </ul>
                                                <div className="text-[30px] text-black font-bold mt-[30px]">Experience</div>
                                                <ul className="text-[20px] leading-[40px] list-disc list-inside">
                                                    <li>Department Chair, Department of Economics, NTHU</li>
                                                    <li>Director, Double Specialty Program of Technology and Management, NTHU</li>
                                                    <li>Standing Director, Taiwan Association of Environmental and Resource Economics (TAERE)</li>
                                                    <li>Editorial Board Member, Journal of Green Economy</li>
                                                    <li>Professor, Department of Economics, NTHU</li>
                                                    <li>Interim Department Chair, Department of Economics, NCKU</li>
                                                    <li>Research Associate, Taiwan Institute of Economic Research (TIER)</li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        }


                        {
                            tab === 'subDirector' && (
                                <div className={cx("flex", mediaQueryLessSM ? 'gap-[120px]' : 'flex-col gap-10 px-[10px]')}>
                                    <div className={cx(!mediaQueryLessSM && 'flex justify-center')}>
                                        <Image src={`/images/subDirector.jpg`} h={467} w={340} radius={30}/>
                                    </div>


                                    {
                                        lang == "tw" && (
                                            <div className="flex flex-col flex-1">
                                            <div className="flex flex-col">
                                                    <div className="text-[30px] text-black">副主任</div>
                                                    <div className="text-[46px] text-[#8d7f4c] font-extrabold">鄭惠君</div>
                                                </div>
                                                <Divider color={"#cedbdc"} mb={40} mt={40}/>
                                                <div className="flex flex-col">
                                                    <div className="text-[30px] text-black font-bold">學歷</div>
                                                    <div className="text-[20px] leading-[40px]">
                                                        <div>國立東華大學 / 科學教育研究所碩士</div>
                                                        <div>逢甲大學 / 企業管理系學士</div>
                                                    </div>

                                                    <div className="text-[30px] text-black font-bold mt-[30px]">經歷</div>
                                                    <div className="text-[20px] leading-[40px]">
                                                        <div>科政中心 / 副主任</div>
                                                        <div>科研資料組 / 組長、副組長</div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        lang == "en" && (
                                            <div className="flex flex-col flex-1">
                                                <div className="flex flex-col">
                                                    <div className="text-[30px] text-black">Deputy Director General</div>
                                                    <div className="text-[46px] text-[#8d7f4c] font-extrabold">
                                                        Hui-Jun Cheng
                                                    </div>
                                                </div>
                                                <Divider color={"#cedbdc"} mb={40} mt={40}/>
                                                <div className="flex flex-col">
                                                    <div className="text-[30px] text-black font-bold">Education</div>
                                                    <ul className="text-[20px] leading-[40px] list-disc list-inside">
                                                        <li>Master, Master Program of Science Education, Department of
                                                            Education and Human Potentials Development, National Dong Hwa
                                                            University
                                                        </li>
                                                        <li>Bachelor, Department of Business Administration, Feng Chia
                                                            University
                                                        </li>
                                                    </ul>

                                                    <div
                                                        className="text-[30px] text-black font-bold mt-[30px]">Experience
                                                    </div>
                                                    <ul className="text-[20px] leading-[40px] list-disc list-inside">
                                                        <li>Deputy Director General, STPI, Taiwan</li>
                                                        <li>Director/Deputy Director, Databases & Information Services Division, STPI, Taiwan
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            )
                        }



                        {/*{*/}
                        {/*  tab === 'subDirector2' && (*/}
                        {/*    <div className={cx("flex", mediaQueryLessSM ? 'gap-[120px]' : 'flex-col gap-10 px-[10px]')}>*/}
                        {/*        <div className={cx(!mediaQueryLessSM && 'flex justify-center')}>*/}
                        {/*            <Image src={`/images/IMG_8241.jpeg`} h={467} w={340} radius={30}/>*/}
                        {/*        </div>*/}


                        {/*        {*/}
                        {/*          lang == "tw" && (*/}
                        {/*            <div className="flex flex-col flex-1">*/}
                        {/*                <div className="flex flex-col">*/}
                        {/*                    <div className="text-[30px] text-black">副主任</div>*/}
                        {/*                    <div className="text-[46px] text-[#8d7f4c] font-extrabold">朱曉萍</div>*/}
                        {/*                </div>*/}
                        {/*                <Divider color={"#cedbdc"} mb={40} mt={40}/>*/}
                        {/*                <div className="flex flex-col">*/}
                        {/*                    <div className="text-[30px] text-black font-bold">學歷</div>*/}
                        {/*                    <div className="text-[20px] leading-[40px]">*/}
                        {/*                        <div>國立臺灣大學 化學工程研究所 博士</div>*/}
                        {/*                        <div>國立臺灣大學 化學工程研究所 碩士</div>*/}
                        {/*                        <div>國立臺灣大學 化學工程學系 學士</div>*/}
                        {/*                    </div>*/}

                        {/*                    <div className="text-[30px] text-black font-bold mt-[30px]">經歷</div>*/}
                        {/*                    <div className="text-[20px] leading-[40px]">*/}
                        {/*                        <div>國立臺灣科技大學研究發展處 研發長</div>*/}
                        {/*                        <div>國立臺灣科技大學校務研究與發展中心 主任</div>*/}
                        {/*                        <div>國立臺灣科技大學研究發展處 副研發長</div>*/}
                        {/*                        <div>國立台灣科技大學科技管理研究所 教授級專業技術人員</div>*/}
                        {/*                        <div>科技部全球事務與科學發展中心 副主任</div>*/}
                        {/*                        <div>科技部工程技術研究發展司 研究員兼副司長</div>*/}
                        {/*                        <div>國家科學委員會工程技術發展處 研究員兼副處長</div>*/}
                        {/*                        <div>財團法人國家實驗研究院科技政策研究與資訊中心 研究員兼副主任</div>*/}
                        {/*                    </div>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*          )*/}
                        {/*        }*/}


                        {/*        {*/}
                        {/*          lang == "en" && (*/}
                        {/*            <div className="flex flex-col flex-1">*/}
                        {/*                <div className="flex flex-col">*/}
                        {/*                    <div className="text-[30px] text-black">Deputy Director General</div>*/}
                        {/*                    <div className="text-[46px] text-[#8d7f4c] font-extrabold">*/}
                        {/*                      Hsiao-Ping Chu*/}
                        {/*                    </div>*/}
                        {/*                </div>*/}
                        {/*                <Divider color={"#cedbdc"} mb={40} mt={40}/>*/}
                        {/*                <div className="flex flex-col">*/}
                        {/*                    <div className="text-[30px] text-black font-bold">Education</div>*/}
                        {/*                    <ul className="text-[20px] leading-[40px] list-disc list-inside">*/}
                        {/*                        <li>Ph.D., Department of Chemical Engineering, National Taiwan University</li>*/}
                        {/*                        <li>Master, Department of Chemical Engineering, National Taiwan University</li>*/}
                        {/*                        <li>Bachelor, Department of Chemical Engineering, National Taiwan University</li>*/}
                        {/*                    </ul>*/}

                        {/*                    <div*/}
                        {/*                      className="text-[30px] text-black font-bold mt-[30px]">Experience*/}
                        {/*                    </div>*/}
                        {/*                    <ul className="text-[20px] leading-[40px] list-disc list-inside">*/}
                        {/*                        <li>Vice President, Office of Research and Development, National Taiwan University of Science and Technology</li>*/}
                        {/*                        <li>Director, Center for Sustainability Development and Institutional Research, National Taiwan University of Science and Technology</li>*/}
                        {/*                        <li>Associate Vice President, Office of Research and Development, National Taiwan University of Science and Technology</li>*/}
                        {/*                        <li>Professor-level Technical Expert, Graduate Institute of Technology Management, National Taiwan University of Science and Technology</li>*/}
                        {/*                        <li>Deputy Director, Center for Global Affairs and Science Engagement, MOST</li>*/}
                        {/*                        <li>Research Fellow and Deputy Director-General, Department of Engineering and Technologies, MOST</li>*/}
                        {/*                        <li>Research Fellow and Deputy Director-General, Department of Engineering and Technologies Development, NSC</li>*/}
                        {/*                        <li>Research Fellow and Deputy Director General, STPI, NARLABS</li>*/}
                        {/*                    </ul>*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*          )*/}
                        {/*        }*/}

                        {/*    </div>*/}
                        {/*  )*/}
                        {/*}*/}

                        {
                            tab === 'hisDirector' && <HisDirector/>
                        }
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default Page
